import { render, staticRenderFns } from "./overview-dashboard.vue?vue&type=template&id=1bcbeb4e&scoped=true&"
import script from "./overview-dashboard.vue?vue&type=script&lang=js&"
export * from "./overview-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./overview-dashboard.vue?vue&type=style&index=0&id=1bcbeb4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcbeb4e",
  null
  
)

export default component.exports